/* eslint-disable no-magic-numbers */

import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import style from './index.module.scss'

const Grid = ({ children, itemsPerRow, nowrap }) => (
  <div
    className={classNames(style.Grid, style[`items${itemsPerRow}`], {
      [style.nowrap]: Boolean(nowrap),
    })}
  >
    {children}
  </div>
)

Grid.propTypes = {
  nowrap: PropTypes.bool,
  itemsPerRow: PropTypes.oneOf([2, 3, 4, 5, 6]),
  children: PropTypes.node,
}

Grid.defaultProps = {
  nowrap: false,
  itemsPerRow: 2,
}

export default Grid
